export default {
  navigation: {
    menuLinks: {
      admin: "Administrator",
      runTask: {
        general: "Tasks launch",
        singleTask: "Single launch",
        multiTask: "Multiple launch"
      },
      statusTask: {
        general: "Tasks status",
        running: "Running tasks",
        finished: "Finished tasks",
        deleted: "Deleted tasks"
      },
      commonTask: {
        general: "Common tasks",
        processes: "Process view",
        services: "Services launch",
        logs: "Logs"
      },
      reference: {
        general: "References",
        databases: "Databases",
        apps: "Sections",
        servers: "Servers",
        users: "Users",
        roles: "Roles",
        appParams: "Section params",
        upgrades: "Upgrades"
      },
      config: {
        general: "Config",
        configTree: "Sections config",
        visuals: "Visual tree",
        configTasks: "Tasks config",
        roleSections: "Bases to roles",
        sectionTasks: "Tasks to sections",
        roleTasks: "Tasks to roles"
      },
      cron: {
        general: "Scheduler",
        scheduler: "Editor",
        history: "History"
      }
    },
    headerTitles: {
      singleTask: "Single task launch",
      multiTask: "Multilaunch of upgrade",
      running: "Running tasks",
      finished: "Finished tasks",
      deleted: "Deleted tasks",
      processes: "Process vies",
      services: "Services view",
      logs: "Logs",
      databases: "Database reference",
      apps: "Sections reference",
      servers: "Servers reference",
      users: "Users reference",
      roles: "Roles reference",
      appParams: "Section params reference",
      upgrades: "Upgrades reference",
      configTree: "Sections config",
      visuals: "Visual tree",
      configTasks: "Tasks config",
      roleSections: "Bases to roles binding",
      roleTasks: "Tasks to roles binding",
      sectionTasks: "Tasks to sections binding",
      scheduler: "Scheduler editor",
      history: "Scheduler history",
      passwordChange: "Password change"
    },
    userMenu: {
      version: "Version",
      mainServerVersion: "Agent version",
      userRole: "Role",
      user: "User",
      serversVersions: "Agents versions",
      hardwareInfo: "Resource control",
      clearLocalStorage: "Clear memory",
      backup: "Backup",
      passwordChange: "Password change",
      themeChange: "Theme change",
      themeTitle: "Choosing a theme",
      themeDark: "Obsidian",
      themeDesktop: "Classic",
      lastErrors: "Last errors",
      exit: "Log out",
      headerDialog: {
        versions: "Versions",
        generalAgentVersion: "Main agent version",
        tinyAgentsVersion: "Tiny Agents Versions",
      },
      headerMessages: {
        plsRefreshPage: "Please refresh the page",
        noMistakes: "No errors",
        lastMistakes: "Last Errors",
      }
    },
    configTaskForm: {
      param: "Parameter",
      name: "Name",
      lenght: "Length",
      cancel: "Cancel"
    },
    configTree: {
      server: "Server",
      servers: "Servers",
      notExported: "not exported",
      notExportedPlural: "not exported"
    },
    commonTree: {
      saveInFile: "Save to file",
      showScroll: "Scroll to the right",
      details: "Details",
      taskNotCompleted: "Task not completed"
    }
  }
};
